import apiClient from 'services/axios'
import ApiConfig from 'services/config';
import errorHandler from 'components/error.handler';

const {ProgramConfig} = ApiConfig;

export async function updateProgram(body) {
  const {businessCode} = body
  delete body.businessCode
  return apiClient
    .post(ProgramConfig.PROGRAM.concat(businessCode), body)
    .then(response => {
      if (response) {
        return response.data
      }
      return false
    })
    .catch(({data}) => {
      errorHandler(data)
    })
}

export async function showProgram(businessCode) {
  return apiClient
    .get(ProgramConfig.PROGRAM.concat(businessCode))
    .then(response => {
      if (response) {
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}